import Product from '@/shared/types/products/product.type';
import Response from '@/shared/types/response';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type Args = {
  productId: string;
  body?: {
    /**
     * optional passing this as true will omit the product itself from unlinking. Only the variant list will be unlinked.
     * If the variant list is empty and this is true nothing will be unlinked.
     */
    exclude_product?: boolean;
    /**
     * optional list. Not passing will unlink on all variants, including the product itself.
     */
    variant_ids: string[];
  };
  onUnauthorized?: () => void;
};

const unlinkInventory = async ({ productId, body, onUnauthorized }: Args) => {
  const token = getCookie('auth_token');

  try {
    return await fetcher<Response<Product[]>>({
      url: `/products/${productId}/unlink_inventory/`,
      method: 'PUT',
      body,
      token,
      onUnauthorized,
    });
  } catch (error) {
    console.error(
      'Error occurred in function "unlinkInventory" in file "src/shared/api/product/unlinkInventory.ts":',
      error,
    );
    return error as Response<Product[]>;
  }
};

export default unlinkInventory;
